<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/115/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/115/title-1.png" alt="" />
                    <div class="content">
                        在金堂企业就业的四大高校排行榜（泰晤士高等教育排名、QS世界大学排名、USNEWS世界大学排名、软科世界大学学术排名）任一榜单排名前100位大学或国内双一流大学毕业生。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/115/title-2.png" alt="" />
                    <div class="content">
                        近5年在四大高校排行榜（泰晤士高等教育排名、QS世界大学排名、USNEWS世界大学排名、软科世界大学学术排名）任一榜单排名前100位大学或国内双一流大学毕业生来金堂企业就业且在我县工作时间满两年的（以社保缴纳为准）。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/115/title-3.png" alt="" />
                    <div class="content">
                        按硕士4万元、博士6万元给予个人补贴。
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/115/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">收集阶段</div>
                                </div>
                                <div class="line-content">
                                    <div >
                                        <span style="font-weight: bold;">组织申报：</span>符合条件的人员向人社局申报。
                                    </div>
                                    <div style="margin-top: 0.22rem;width: 100%;height:0.02rem;background-color: #3D5AA3;"></div>
                                    <div style="margin-top: 0.22rem;">
                                        <div>所需资料：</div>
                                        <div>1. 引才补贴申请表；</div>
                                        <div>2. 企业营业执照复印件；</div>
                                        <div>3.本人身份证、学历学位证书、学历学位鉴定证明、银行账户、劳动合同（2年及以上）、社保缴纳证明（2年及以上）等材料的原件及复印件。</div>
                                        <div>学历学位鉴定证明，可提供教育部留学服务中心认证的《国外学历学位认证书》、《港澳台学历学位认证书》或四川省人社厅专家服务中心认证的《四川省海外留学人员证书》，也可登录教育部留学服务中心网上服务大厅在线查询，并提供查询结果截图。上述材料的复印件均需加盖单位鲜章。</div>
                                    </div>
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">审核拨付阶段</div>
                                </div>
                                <div class="line-content">
                                    <div >
                                        <span style="font-weight: bold;">1.审核：</span>县人社局、县教育局审核申报材料。
                                    </div>
                                    <div >
                                        <span style="font-weight: bold;">2.公示：</span>对审核通过的公示不少于5个工作日。
                                    </div>
                                    <div >
                                        <span style="font-weight: bold;">3.拨付：</span>经公示无异议的，县人社局按照补贴名单和标准，按程序申请资金并拨付到申请人银行账户。
                                    </div>
                                    <div style="margin-top: 0.22rem;width: 100%;height:0.02rem;background-color: #3D5AA3;"></div>
                                    <div style="margin-top: 0.22rem;">
                                        <div>所需资料：</div>
                                        <div>1. 引才补贴申请表；</div>
                                        <div>2. 企业营业执照复印件；</div>
                                        <div>3.本人身份证、学历学位证书、学历学位鉴定证明、银行账户、劳动合同（2年及以上）、社保缴纳证明（2年及以上）等材料的原件及复印件。</div>
                                        <div>学历学位鉴定证明，可提供教育部留学服务中心认证的《国外学历学位认证书》、《港澳台学历学位认证书》或四川省人社厅专家服务中心认证的《四川省海外留学人员证书》，也可登录教育部留学服务中心网上服务大厅在线查询，并提供查询结果截图。上述材料的复印件均需加盖单位鲜章。</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl" style="margin-top: 0.8rem;">
                    <img class="top" src="./../assets/imgs/115/title-5.png" alt="" />
                    <div class="content" style="font-weight: bold;font-size: 0.3rem;">
                        依据每年度通知时间确定
                    </div>
                </div>

                <div class="contact">
                    <img class="top" src="./../assets/imgs/113/title-6.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-84997016">028-84997016</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            金堂县人社局事管室
                        </div>
                        <div class="unit">
                            <span class="label">联系地址：</span>
                            四川省成都市金堂县十里大道二段89号
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                font-size: 0.26rem;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;
            }
        }


        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .fund {
            position: relative;
            margin-top: 0.8rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .text {
                    background-color: #fff;
                    box-sizing: border-box;
                    padding: 0.42rem 0.25rem;
                    font-size: 0.26rem;
                    border-radius: 0.26rem;
                    color: #4e4e4e;
                }
            }
        }


    }
}
</style>
